export default [
  {
    path: '/work-mode',
    name: 'work-mode',
    component: () => import('@/views/pages/management/work-mode/List.vue'),
    meta: {
      name: 'Work Mode',
      resource: 'Management - Mode Kerja',
      action: 'manage',
    },
  },
]
